export default __webpack_public_path__ + "static/media/delivery_bus.d3af9089.svg";